import { SmallAddIcon } from "@chakra-ui/icons";
import { Box, Button, Flex, Heading } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../hooks/use-user";
import NoPermissionRead from "../../ui/components/ui/NoPermission";
import { DataTable } from "./DataTable";

export const ApplicantsParent = () => {
  const { user } = useUser();
  if (!user) return null;
  return (
    <>
      {user.permissionApplicants === "NONE" && !user.permissionOrganizationAdmin ? (
        <NoPermissionRead title="Bewerber" />
      ) : (
        <Applicants />
      )}
    </>
  );
};

const Applicants = () => {
  const { user } = useUser();
  const navigate = useNavigate();

  if (!user) return null;

  return (
    <Flex direction="column" padding="1rem 1.5rem">
      <Flex width="100%" justifyContent="space-between" margin="0 0 1.5em">
        <Heading size="lg">Übersicht der Bewerber</Heading>
        <Flex gap="1rem">
          <Button
            colorScheme="primary"
            color="white"
            className="flex gap-2 p-2"
            variant="solid"
            onClick={() => {
              navigate(`/bewerber/neu`);
            }}
            isDisabled={
              user.permissionApplicants !== "FULL" &&
              user.permissionApplicants !== "WRITE" &&
              !user.permissionOrganizationAdmin
            }
          >
            <Box
              className="text-primary"
              display="flex"
              alignItems="center"
              justifyContent="center"
              borderRadius="50%"
              bg="white"
              boxSize="1rem"
            >
              <SmallAddIcon />
            </Box>
            <span>Bewerber manuell hinzufügen</span>
          </Button>
        </Flex>
      </Flex>
      <DataTable />
    </Flex>
  );
};

export { Applicants };
